// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsComposeOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.618 6.113a.225.225 0 0 0 0 .318l.951.951c.088.088.23.088.318 0l.961-.961a.225.225 0 0 0 0-.318l-.95-.952a.225.225 0 0 0-.319 0zm-.966 1.286a.225.225 0 0 0-.318 0L5.294 17.444l-.286 1.282a.225.225 0 0 0 .267.27l1.289-.283L16.603 8.668a.225.225 0 0 0 0-.318zM20.6 5.308c.493.492.568 1.34.018 1.89L7.764 20.06a1.47 1.47 0 0 1-.73.394L4.538 21l-.104-.002c-.441-.006-.785-.244-.983-.44-.198-.196-.436-.535-.45-.972v-.012L3 19.454l.555-2.486c.059-.262.185-.516.392-.723L16.801 3.383c.551-.552 1.4-.476 1.892.017zM20.5 19a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsComposeOutlined;
